import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';

/**
 * RequireAuth
 * --------------------------------------------------------------------
 * Gate that:
 *   - shows a spinner while the auth bootstrap is in flight,
 *   - redirects to /website_admin/login if unauthenticated,
 *   - renders children otherwise.
 */
export default function RequireAuth({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'idle' || status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex items-center gap-2 text-gray-500 text-sm">
          <Loader size={16} className="animate-spin" />
          Checking session…
        </div>
      </div>
    );
  }

  if (status !== 'authenticated') {
    return (
      <Navigate to="/website_admin/login" replace state={{ from: location }} />
    );
  }

  return children;
}
